// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "geopop/it/pa/sdk-client") return "geopop/it/chunks/pa/sdk-client.js";
	if (chunkId === "geopop/it/pa/gui") return "geopop/it/chunks/pa/gui.js";
	if (chunkId === "common/sdk/firebasePushNot") return "common/sdk/firebasePushNot.js";
	if (chunkId === "common/sdk/firebaseLogin") return "common/sdk/firebaseLogin.js";
	// return url for filenames based on template
	return undefined;
};